import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
            companies: [],
            pages: {},
            currentCompany: {}
        };
    },

    mutations: {
        setCompanies(state, data) {
            state.companies = data;
        },
        setPages(state, data) {
            state.pages = data;
        },
        setCurrentCompany(state, data) {
            state.currentCompany = data;
        },
        clearStore(state) {
            state.companies = {};
            state.currentCompany = {};
            state.pages = {};
        }
    },
    actions: {
        loadList({ state, commit }) {
            return new Promise((resolve, reject) => {
                api.get('/company/').then(response => {
                    commit('setCompanies', response.data.data.companies);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        getPaginatedList({ state, commit }, params) {
            return new Promise((resolve, reject) => {
                api.get('/company/?' + qs.stringify(params)).then(response => {
                    commit('setCompanies', response.data.data);
                    commit('setPages', response.data.meta);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        async getSearchList({ state, commit }, params) {
            try {
                const response = await api.get('/company/?' + qs.stringify(params));
                return response.data.data;
            } catch (e) {
                throw new Error(e);
            }
        },
        getCompany(context, companyId) {
            return new Promise((resolve, reject) => {
                api.get('/company/' + companyId).then(
                    response => {
                        //this.commit('setCurrentEmployer', response.data.data);
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    });
            });
        },
        getCompanyByQuery(context, queryString) {
            return new Promise((resolve, reject) => {
                api.post('/company/find', { query: queryString }).then(
                    response => {
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    });
            });
        },
        updateCompany(context, data) {
            return new Promise((resolve, reject) => {
                api.put('/company/' + data.id, data).then(
                    response => {
                        //this.commit('setCurrentEmployer', response.data.data);
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    });
            });
        },
        createCompany(context, data) {
            return new Promise((resolve, reject) => {
                api.post('/company/', data).then(
                    response => {
                        //this.commit('setCurrentEmployer', response.data.data);
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    });
            });
        }
    },
    getters: {}

};

export default store;
